export enum FiduciarySearchTerms {
  Date = "Fecha",
  Escrow = "Fideicomiso",
  Application = "Número de Solicitud",
  ApplicationTypes = "Tipo Solicitud",
  Status = "Estatus",
  All = "Varios Criterios",
}
